export enum PaymentMethodForms {
  AddPaymentMethod = 'AddPaymentMethod',
  DeletePaymentMethod = 'DeletePaymentMethod',
}
